"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useFilterLocalDateTimeCellFactory = exports.FilterLocalDateTimeCell = void 0;
const react_1 = __importDefault(require("react"));
const local_date_time_field_1 = require("../../../components/local-date-time-field/local-date-time-field");
const filter_interval_cell_factory_1 = require("./filter-interval-cell-factory");
exports.FilterLocalDateTimeCell = (0, filter_interval_cell_factory_1.filterIntervalCellFactory)(local_date_time_field_1.LocalDateTimeField);
function useFilterLocalDateTimeCellFactory(representation) {
    const Field = (props) => (react_1.default.createElement(local_date_time_field_1.LocalDateTimeField, { ...props, representation: representation }));
    return (0, filter_interval_cell_factory_1.filterIntervalCellFactory)(Field);
}
exports.useFilterLocalDateTimeCellFactory = useFilterLocalDateTimeCellFactory;
//# sourceMappingURL=filter-local-date-time-cell.js.map